import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash/fp';

import cookiesFactory from '../../../../../../../base/cookies-factory';
import TrashIcon from '../../../../../themes/svg/trashIcon';

import { Attribute, Name, Action, Icon, Value } from './styles';

const deletableAttributes = [
  'motorized',
];

const ItemAttribute = ({
  name,
  label,
  value,
  onDelete,
}) => {
  const deleteAttribute = useCallback(() => {
    onDelete(name);
  }, [name]);

  const isInternalUser = cookiesFactory.isInternalUser();
  const canDelete = useMemo(
    () => (
      includes(name, deletableAttributes) && isInternalUser
    ),
    [name, isInternalUser],
  );

  return (
    <Attribute>
      <Name>
        {label}
      </Name>
      <Value>
        {value}
      </Value>
      {canDelete && (
        <Action>
          <Icon onClick={deleteAttribute}>
            <TrashIcon />
          </Icon>
        </Action>
      )}
    </Attribute>
  );
};

ItemAttribute.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ItemAttribute;
